import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'viewer-pen-width-slider',
  templateUrl: './pen-width-slider.component.html',
  styleUrl: './pen-width-slider.component.scss',
})
export class PenWidthSliderComponent {
  @Input() width: number = 2;
  @Input() min: number = 0.5;
  @Input() max: number = 20;
  @Input() step: number = 0.5;
  @Output() widthChange = new EventEmitter<number>();
}
